var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 240,
    fill: "#389E0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.164 169.164c6.248-6.248 16.379-6.248 22.627 0 6.248 6.248 6.248 16.379 0 22.627l-160 160c-6.248 6.248-16.379 6.248-22.627 0l-80-80c-6.248-6.248-6.248-16.379 0-22.627 6.248-6.248 16.379-6.248 22.627 0L220 318.373l149.164-149.209z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.9844530c7ac7735cb249ed92039ed0a1.svg";
export { ForwardRef as ReactComponent };